import React from "react";

import { classNames } from "@greeter/util";

import css from "./SlideBox.module.scss";

export const SlideBox = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return <div {...props} ref={ref} {...classNames(css.slideBox, className)} />;
});
